import debugLib from 'debug'

import {
  ANALYTICS_UPDATE_DIGITAL_DATA,
  ANALYTICS_UPDATE_USER_INFO,
  ANALYTICS_GET_PAGE_HEAD_ANALYTICS,
  ANALYTICS_DO_TRACK,
  ANALYTICS_PUSH_EVENT_AND_TRACK,
  ANALYTICS_PUSH_RECOMMENDATION,
  ANALYTICS_PUSH_PRODUCT_CARE_LIGHTBOX,
  ANALYTICS_CLEAR_PRODUCT_CARE_LIGHTBOX,
  ANALYTICS_HANDLE_ADD_PRODUCT_TO_OFFER,
  ANALYTICS_HANDLE_CHANGE_PAGE_FOR_STEP,
  ANALYTICS_HANDLE_CHANGE_PRODUCT_IN_STEP,
  ANALYTICS_HANDLE_ANALYTICS_SET_UP,
  ANALYTICS_PUSH_AR3D_IN_PAGE
} from '../actionTypes/analyticsActionTypes'

import getCookie from '../helpers/getCookie'
import getOfferType from '../helpers/getOfferType'

const debug = debugLib('Analytics')

function updateDigitalData(stores, reason) {
  const ANALYTICS_DATA_OBJECT = window.digitalData

  // Common digitalData attributes and userInfo tracking across both special offers creator and PDP
  ANALYTICS_DATA_OBJECT.page.pageInfo = ANALYTICS_DATA_OBJECT.page.pageInfo || {}
  ANALYTICS_DATA_OBJECT.page.attributes = ANALYTICS_DATA_OBJECT.page.attributes || {}
  ANALYTICS_DATA_OBJECT.page.category = ANALYTICS_DATA_OBJECT.page.category || {}
  ANALYTICS_DATA_OBJECT.product[0] = ANALYTICS_DATA_OBJECT.product[0] || {}

  const ON_SPECIAL_OFFER_PAGE = !!stores.specialOffersCreatorStore.promotionId
  const HAS_ERROR = stores.productStore.meta.errorCode

  if (ON_SPECIAL_OFFER_PAGE && stores.specialOffersCreatorStore.attributes) {
    const PRODUCT_ID = stores.specialOffersCreatorStore.attributes.targetPartNumber
    const PROMOTION_ID = stores.specialOffersCreatorStore.promotionId
    const ATTRIBUTES = stores.specialOffersCreatorStore.attributes
    const productStoreData = stores.productStore.data || {}
    const BREADCRUMB = productStoreData.breadcrumb.map(cat => cat.name)
    const OFFER_TYPE = getOfferType(ATTRIBUTES)

    ANALYTICS_DATA_OBJECT.page.pageInfo.pageName = `ar:specialoffers:${PRODUCT_ID}:${PROMOTION_ID.toLowerCase()}:`
    ANALYTICS_DATA_OBJECT.page.pageInfo.siteSection = 'ar:specialoffers:'

    ANALYTICS_DATA_OBJECT.page.category.pageType = 'so'
    ANALYTICS_DATA_OBJECT.page.category.subCategory1 = BREADCRUMB[0] || ''
    ANALYTICS_DATA_OBJECT.page.category.subCategory2 = BREADCRUMB[1] || ''
    ANALYTICS_DATA_OBJECT.page.category.subCategory3 = BREADCRUMB[2] || ''

    ANALYTICS_DATA_OBJECT.product[0].productInfo = { productID: PRODUCT_ID }

    ANALYTICS_DATA_OBJECT.page.attributes.platform = 'react_so'
    ANALYTICS_DATA_OBJECT.page.attributes.specialOfferId = PROMOTION_ID
    ANALYTICS_DATA_OBJECT.page.attributes.specialOfferShortDescription = ATTRIBUTES.shortDescription
    ANALYTICS_DATA_OBJECT.page.attributes.specialOfferLongDescription = ATTRIBUTES.longDescription

    if (OFFER_TYPE.isSetBundleOffer) {
      ANALYTICS_DATA_OBJECT.page.attributes.specialOfferChoiceStep = 'Review'
    }
    if (OFFER_TYPE.isSetBundleOffer) {
      ANALYTICS_DATA_OBJECT.page.attributes.specialOfferType = 'isSetBundleOffer'
    }
    if (OFFER_TYPE.isBuilderOffer) {
      ANALYTICS_DATA_OBJECT.page.attributes.specialOfferType = `isBuilderOffer:${ATTRIBUTES.productSets.length - 1}`
    }
    if (OFFER_TYPE.isBuilderOffer) {
      ANALYTICS_DATA_OBJECT.page.attributes.specialOfferChoicePageNumber = 1
    }
    if (OFFER_TYPE.isBuilderOffer) {
      ANALYTICS_DATA_OBJECT.page.attributes.specialOfferChoiceStep = 'Product 1'
    }
  } else if (HAS_ERROR) {
    ANALYTICS_DATA_OBJECT.page.pageInfo.siteSection = 'ar:productdetails'
    ANALYTICS_DATA_OBJECT.page.pageInfo.pageName = `ar:error:pdp-${HAS_ERROR}`
    ANALYTICS_DATA_OBJECT.page.attributes.platform = 'react_pdp'
  } else {
    const productStoreData = stores.productStore.data || {}
    const PRODUCT_NAME = productStoreData.productName
      .toLowerCase()
      .replace(/\.$/g, '')
      .replace(/\s+/g, '')
    const PRODUCT_ID = productStoreData.productId
    const PRODUCT_PRICE = productStoreData.prices && productStoreData.prices.attributes.now

    // page lightBox
    ANALYTICS_DATA_OBJECT.page.lightBox = {}

    // page.pageInfo
    ANALYTICS_DATA_OBJECT.page.pageInfo.siteSection = stores.storeLocatorStore.storeSelectorOpen
      ? 'ar:storelocator:'
      : 'ar:productdetails:'
    ANALYTICS_DATA_OBJECT.page.pageInfo.categoryID = productStoreData.breadcrumb.map(cat => cat.id)

    // Store selector conditional pageInfo
    if (!stores.storeLocatorStore.storeSelectorOpen) {
      ANALYTICS_DATA_OBJECT.page.pageInfo.pageName = `ar:pdp:${PRODUCT_ID}:${PRODUCT_NAME}:`
    } else {
      const condition = !stores.storeLocatorStore.storeList.length && !stores.storeLocatorStore.localityList.length
      if (condition) {
        ANALYTICS_DATA_OBJECT.page.pageInfo.pageName = 'ar:productdetails:storelocator:main:'
      } else if (stores.storeLocatorStore.localityList.length) {
        ANALYTICS_DATA_OBJECT.page.pageInfo.pageName = 'ar:productdetails:storelocator:locationsList:'
      } else if (stores.storeLocatorStore.storeList.length) {
        ANALYTICS_DATA_OBJECT.page.pageInfo.pageName = 'ar:productdetails:storelocator:storesList:'
      }
    }

    const STORE_LIST = stores.storeLocatorStore.storeList
    const REFERRED_FROM_MCOMM = document.referrer.indexOf('argos.co.uk/m/') > -1

    // page.attributes
    ANALYTICS_DATA_OBJECT.page.attributes = ANALYTICS_DATA_OBJECT.page.attributes || {}
    ANALYTICS_DATA_OBJECT.page.attributes.platform = stores.storeLocatorStore.storeSelectorOpen
      ? 'react_pdpStoreLocator'
      : 'react_pdp'
    ANALYTICS_DATA_OBJECT.page.attributes.numberOfStoresOffered = STORE_LIST.length
    ANALYTICS_DATA_OBJECT.page.attributes.numberOfStoresWithInStock = STORE_LIST.filter(
      store => store.stockIcon === 'tick'
    ).length
    ANALYTICS_DATA_OBJECT.page.attributes.numberOfStoresWithLeadTime = STORE_LIST.filter(
      store => store.stockIcon === 'clock' || store.stockIcon === 'calendar'
    ).length
    ANALYTICS_DATA_OBJECT.page.attributes.numberOfStoresWithOutOfStock = STORE_LIST.filter(
      store => store.stockIcon === 'cross'
    ).length
    ANALYTICS_DATA_OBJECT.page.attributes.channel =
      getCookie('analytics_channel') === 'mcomm' || REFERRED_FROM_MCOMM ? 'uk:mobile' : 'uk:desktop'

    ANALYTICS_DATA_OBJECT.page.attributes.recommendations = ANALYTICS_DATA_OBJECT.page.attributes.recommendations || []

    // Determine the stock code for the first store in the list
    if (STORE_LIST.length && [0].stockIcon === 'tick') {
      ANALYTICS_DATA_OBJECT.page.attributes.collectionStockCode = 0
    } else if (STORE_LIST.length && [0].stockIcon === 'clock') {
      ANALYTICS_DATA_OBJECT.page.attributes.collectionStockCode = 1
    } else if (STORE_LIST.length && [0].stockIcon === 'cross') {
      ANALYTICS_DATA_OBJECT.page.attributes.collectionStockCode = 2
    }

    // page.category
    ANALYTICS_DATA_OBJECT.page.category.pageType = 'pdp'
    for (let index = 0; index < productStoreData.breadcrumb.length; index += 1) {
      ANALYTICS_DATA_OBJECT.page.category[`subCategory${index + 1}`] = productStoreData.breadcrumb[index].name
    }
    ANALYTICS_DATA_OBJECT.page.category.isHabitatProduct = productStoreData.attributes.channels?.includes('HABITAT_UK')

    // product[0].productInfo
    ANALYTICS_DATA_OBJECT.product[0].productInfo = {
      productID: productStoreData.productId,
      productName: productStoreData.productName
    }

    if (productStoreData.productId.startsWith('tuc')) {
      ANALYTICS_DATA_OBJECT.product[0].productInfo.parentSKU = productStoreData.attributes.parentId || ''
    }

    // MVT experiments
    ANALYTICS_DATA_OBJECT.experiments = []

    // product[0].attributes
    const FFM_METHODS = []
    const VARIANT_TYPE = Object.keys(productStoreData.variants.attributes.variants)[0]
    const VARIANT_OPTS = VARIANT_TYPE ? productStoreData.variants.attributes.variants[VARIANT_TYPE] : null
    const VARIANT_CHOSEN = VARIANT_TYPE
      ? Object.keys(VARIANT_OPTS).find(opt => VARIANT_OPTS[opt].partNumber === productStoreData.productId)
      : null
    if (productStoreData.attributes.collectable) {
      FFM_METHODS.push('collection')
    }
    if (productStoreData.attributes.deliverable) {
      FFM_METHODS.push('delivery')
    }

    const storeIdValue = stores.storeLocatorStore.storeNumber
      ? parseInt(stores.storeLocatorStore.storeNumber, 10)
      : null
    const collectionStoreValue = stores.storeLocatorStore.convenienceStore ? 'collectionPoint' : 'regular'
    const alternativeStoreValue = stores.storeLocatorStore.alternativeStore
      ? stores.storeLocatorStore.alternativeStore.storeId
      : null

    const HAS_REVIEWS =
      stores.bazaarVoiceReviewStore &&
      stores.bazaarVoiceReviewStore.stats &&
      stores.bazaarVoiceReviewStore.stats.attributes
    const QA_STATS =
      stores.bazaarVoiceQuestionAnswerStore &&
      stores.bazaarVoiceQuestionAnswerStore.stats &&
      stores.bazaarVoiceQuestionAnswerStore.stats.attributes

    const prices = productStoreData.prices
    const badges =
      productStoreData.badges &&
      productStoreData.badges.map(badge => badge.attributes.badgeText || badge.attributes.badgeReference)

    const careOffered =
      productStoreData.productCare &&
      productStoreData.productCare.warranties &&
      productStoreData.productCare.warranties.length > 0

    const monthlyCareOffered = !!(
      careOffered && productStoreData.productCare.warranties.find(attr => attr.type.startsWith('monthly_care'))
    )

    ANALYTICS_DATA_OBJECT.product[0].attributes = {
      unitPriceWithTax: prices && prices.attributes.now,
      starRating: HAS_REVIEWS ? HAS_REVIEWS.overallRating : 0,
      numberOfReviews: HAS_REVIEWS ? HAS_REVIEWS.reviewCount : 0,
      fulfillmentMethod: FFM_METHODS.join('|'),
      promotion: !!(prices && prices.attributes.was),
      brandRangeLink: productStoreData.attributes.brand,
      numberOfQuestions: QA_STATS ? QA_STATS.questionCount : 0,
      numberOfAnswers: QA_STATS ? QA_STATS.answerCount : 0,
      existingProductOptions: VARIANT_TYPE ? VARIANT_TYPE.toLowerCase() : null,
      selectedProductOptions: VARIANT_TYPE
        ? `selected:${VARIANT_TYPE}:${VARIANT_CHOSEN}`.toLowerCase().replace(/\s+/g, '')
        : null,
      fastTrackBanner: productStoreData.attributes.fastTrack ? 'pdp:banner:fastTrack' : null,
      storeID: storeIdValue,
      collectionStoreType: collectionStoreValue,
      alternativesStore: alternativeStoreValue,
      priceMessage: prices && prices.attributes.flashText,
      badges,
      cnetContent: productStoreData.isCNETContent,
      careOffered,
      monthlyCareOffered
    }

    ANALYTICS_DATA_OBJECT.product[0].attributes.collectionStockLevelMessage = stores.storeLocatorStore.collectionMessage
      ? stores.storeLocatorStore.collectionMessage.trim()
      : null
    ANALYTICS_DATA_OBJECT.product[0].attributes.collectionStockCode = stores.storeLocatorStore.collectionStockCode
    ANALYTICS_DATA_OBJECT.product[0].attributes.collectionMessageKey = stores.storeLocatorStore.collectionMessageKey
    ANALYTICS_DATA_OBJECT.product[0].attributes.deliveryMessageKey = stores.storeLocatorStore.deliveryMessageKey

    if (stores.storeLocatorStore.deliveryMessage) {
      ANALYTICS_DATA_OBJECT.product[0].attributes.deliveryStockLevelMessage = stores.storeLocatorStore.deliveryMessage.trim()
    }
    ANALYTICS_DATA_OBJECT.product[0].attributes.deliveryStockCode = stores.storeLocatorStore.deliveryCode

    // Special offers specific information on the PDP page
    if (productStoreData.offers) {
      ANALYTICS_DATA_OBJECT.page.attributes.specialOffersNumber = productStoreData.offers.length || 0
      ANALYTICS_DATA_OBJECT.page.attributes.specialOffersTypes = [].concat(
        ...productStoreData.offers.map(({ attributes }) =>
          Object.keys(getOfferType(attributes)).filter(key => getOfferType(attributes)[key])
        )
      )
      ANALYTICS_DATA_OBJECT.page.attributes.specialOffersIDs = productStoreData.offers.map(item => item.id)
    }
    // Bundles analytics

    const essentialExtrasData = stores.essentialExtrasStore
    if (essentialExtrasData && essentialExtrasData.id && essentialExtrasData.name && essentialExtrasData.price) {
      ANALYTICS_DATA_OBJECT.page.attributes.bundles = [
        {
          bundleId: `${PRODUCT_ID}+${essentialExtrasData.id}`,
          items: {
            main: {
              id: PRODUCT_ID,
              price: PRODUCT_PRICE,
              name: productStoreData.productName
            },
            additional: [
              {
                id: essentialExtrasData.id,
                price: essentialExtrasData.price.now,
                name: essentialExtrasData.name
              }
            ]
          },
          bundlePlacement: 'hero',
          bundleType: 'essentialExtrasBundle'
        }
      ]
    }

    // Media player analytics
    ANALYTICS_DATA_OBJECT.component = []
    const media = productStoreData.media
    Object.keys(media).forEach(
      key =>
        key !== 'meta' &&
        key !== 'pdfs' &&
        key !== 'threesixty' &&
        media[key].forEach((item, index) => {
          ANALYTICS_DATA_OBJECT.component.push({
            componentInfo: {
              componentType: key,
              componentID: media[key][index].includes('media.4rgos.it')
                ? /(\w|\d)+$/g.exec(media[key][index])[0]
                : media[key][index]
            }
          })
        })
    )
    if (media.threesixty && media.threesixty.length) {
      ANALYTICS_DATA_OBJECT.component.push({
        componentInfo: {
          componentType: 'threesixty',
          componentID: /(\w|\d)+$/g.exec(media.threesixty[0])[0]
        }
      })
    }
  }
  debug(`DigitalData object updated due to ${reason}`, window.digitalData)
}

function getPageHeadAnalytics(stores) {
  const ON_SPECIAL_OFFER_PAGE = !!stores.specialOffersCreatorStore.data.promotionId

  const PRODUCT_NOT_FOUND =
    !ON_SPECIAL_OFFER_PAGE && (stores.productStore.meta.errorDetail || stores.productStore.meta.errorCode)
  const OFFER_NOT_FOUND =
    ON_SPECIAL_OFFER_PAGE &&
    (stores.specialOffersCreatorStore.meta.errorCode || stores.specialOffersCreatorStore.meta.errorDetail)

  if (PRODUCT_NOT_FOUND || OFFER_NOT_FOUND) {
    return 'window.digitalData = {}'
  }

  const initialDataObject = { page: { pageInfo: {}, attributes: {}, category: {} } }

  const PRODUCT_NAME = ON_SPECIAL_OFFER_PAGE
    ? ''
    : stores.productStore.data.productName
        .toLowerCase()
        .replace(/\.$/g, '')
        .replace(/\s+/g, '')
  const PRODUCT_ID = ON_SPECIAL_OFFER_PAGE
    ? stores.specialOffersCreatorStore.data.attributes.targetPartNumber
    : stores.productStore.data.productId
  const PROMOTION_ID = ON_SPECIAL_OFFER_PAGE ? stores.specialOffersCreatorStore.data.promotionId : ''

  initialDataObject.page.pageInfo.pageName = ON_SPECIAL_OFFER_PAGE
    ? `ar:specialoffers:${PRODUCT_ID}:${PROMOTION_ID.toLowerCase()}:`
    : `ar:pdp:${PRODUCT_ID}:${PRODUCT_NAME}:`
  initialDataObject.page.pageInfo.siteSection = ON_SPECIAL_OFFER_PAGE ? 'ar:specialoffers:' : 'ar:productdetails:'
  initialDataObject.page.attributes.platform = ON_SPECIAL_OFFER_PAGE ? 'react_so' : 'react_pdp'
  initialDataObject.page.category.pageType = ON_SPECIAL_OFFER_PAGE ? 'so' : 'pdp'

  const script = `var getCookie = ${getCookie.toString()};var is_from_mcomm = document.referrer.indexOf('argos.co.uk/m/') > -1`
  const setChannelValue = "getCookie('analytics_channel') === 'mcomm' || is_from_mcomm ? 'uk:mobile' : 'uk:desktop'"
  return `${script};window.digitalData = ${JSON.stringify(
    initialDataObject
  )};digitalData.page.attributes.channel = ${setChannelValue}`
}

function doTrack(event) {
  debug(`Firing _satellite.track for event '${event}' with payload\n`, window.digitalData)
  const waitForDigitalDataAndTrack = () => {
    if (window.digitalData.track) {
      window.digitalData.track(event)
    } else {
      setTimeout(() => waitForDigitalDataAndTrack, 150)
    }
  }
  waitForDigitalDataAndTrack()
}

function pushEventAndTrack(event, eventName, eventRef) {
  window.digitalData = window.digitalData || {}
  window.digitalData.event = window.digitalData.event || []
  window.digitalData.track = window.digitalData.track || (() => {})
  const events = window.digitalData.event
  events.push(event)
  debug('Pushed event', JSON.stringify(event, null, 2))

  const resolvedName = eventName || event.eventInfo.eventName
  debug(`Firing digitalData.track for event '${resolvedName}'`)
  if (eventRef) {
    window.digitalData.track(resolvedName, { eventRef })
  } else {
    window.digitalData.track(resolvedName)
  }
}

function getRecomendationIndexByTitle(title, digitalDataRecommendations) {
  return digitalDataRecommendations.findIndex(recommendation => recommendation.title === title)
}

export function pushRecommendation(newRecommendation) {
  window.digitalData.page.attributes.recommendations = window.digitalData.page.attributes.recommendations || []
  const { recommendations } = window.digitalData.page.attributes
  const recommendationIndex = getRecomendationIndexByTitle(newRecommendation.title, recommendations)
  if (recommendationIndex === -1) {
    recommendations.push(newRecommendation)
    debug('Pushed recommendation', JSON.stringify(newRecommendation, null, 2))
  } else {
    recommendations[recommendationIndex] = newRecommendation
    debug('Updated recommendation', JSON.stringify(newRecommendation, null, 2))
  }
}

function pushProductCareLightBox(productList) {
  window.digitalData.page.lightBox.product = window.digitalData.page.lightBox.product || []
  const { product } = window.digitalData.page.lightBox
  window.digitalData.page.lightBox.type = 'productCare'
  if (product.length) return
  productList.forEach(item => product.push(item))
  window.digitalData.track('productCareLbPage')
}

function clearProductCareLightBox() {
  window.digitalData.page.lightBox = {}
}

function handleAddProductToOffer(partNumber, inReviewStage, currentStep) {
  pushEventAndTrack({
    eventInfo: {
      eventName: 'so_addToOffer',
      eventAction: 'add product to offer'
    },
    attributes: {
      productID: partNumber
    }
  })
  window.digitalData.page.attributes.specialOfferChoicePageNumber = inReviewStage ? undefined : 1
  window.digitalData.page.attributes.specialOfferChoiceStep = inReviewStage ? 'Review' : `Product ${currentStep + 1}`
  debug('DigitalData object updated due to page change', window.digitalData)
}

function handleChangePageForStep(trackNewPage, pageNumber) {
  window.digitalData.page.attributes.specialOfferChoicePageNumber = pageNumber
  if (trackNewPage) {
    pushEventAndTrack({
      eventInfo: {
        eventName: 'so_paginate',
        eventAction: 'paginate across products'
      },
      attributes: {
        pageNumber: parseInt(pageNumber, 10)
      }
    })
  }
}

function handleChangeProductInStep(step, product) {
  window.digitalData.page.attributes.specialOfferChoiceStep = `Product ${step + 1}`
  window.digitalData.page.attributes.specialOfferChoicePageNumber = 1
  pushEventAndTrack({
    eventInfo: {
      eventName: 'so_changeProduct',
      eventAction: 'change product from offer'
    },
    attributes: {
      productID: product
    }
  })
}

function handleAnalyticsSetUp() {
  window.digitalData = {
    ...window.digitalData,
    page: window.digitalData && window.digitalData.page ? window.digitalData.page : {},
    user: window.digitalData && window.digitalData.user ? window.digitalData.user : [{}],
    product: window.digitalData && window.digitalData.product ? window.digitalData.product : [{}]
  }
}

function pushAr3dInPage(value) {
  window.digitalData = window.digitalData || {}
  window.digitalData.product = window.digitalData.product || []
  window.digitalData.product[0] = window.digitalData.product[0] || {}
  window.digitalData.product[0].attributes = window.digitalData.product[0].attributes || {}
  window.digitalData.product[0].attributes.ar3d = value
}

function updateUserInfo(userInfo) {
  const { userState } = userInfo
  let loginStatus = 'Registered'
  if (userState === 'GUEST') {
    loginStatus = 'Non-Registered'
  } else if (userState === 'RECOGNISED') {
    loginStatus = 'Recognised'
  }
  window.digitalData.user[0].profile = [
    {
      ...window.digitalData.user[0].profile,
      profileInfo: {
        profileID: userInfo.userId
      },
      attributes: {
        globalView:
          document.cookie.indexOf('PostCodeSessionCookie') < 0 || getCookie('PostCodeSessionCookie') === '%2C%2C',
        loginStatus
      }
    }
  ]
  doTrack('pdp_initialLoad')
}

const analyticsMiddleware = () => next => action => {
  const { type, payload } = action
  switch (type) {
    case ANALYTICS_UPDATE_DIGITAL_DATA:
      return updateDigitalData(payload.stores, payload.reason)
    case ANALYTICS_UPDATE_USER_INFO:
      return updateUserInfo(payload.userInfo)
    case ANALYTICS_GET_PAGE_HEAD_ANALYTICS:
      return getPageHeadAnalytics(payload.stores)
    case ANALYTICS_DO_TRACK:
      return doTrack(payload.event)
    case ANALYTICS_PUSH_EVENT_AND_TRACK:
      return pushEventAndTrack(payload.event, payload.eventName, payload.eventRef)
    case ANALYTICS_PUSH_RECOMMENDATION:
      return pushRecommendation(payload.recommendation)
    case ANALYTICS_PUSH_PRODUCT_CARE_LIGHTBOX:
      return pushProductCareLightBox(payload.productList)
    case ANALYTICS_CLEAR_PRODUCT_CARE_LIGHTBOX:
      return clearProductCareLightBox()
    case ANALYTICS_HANDLE_ADD_PRODUCT_TO_OFFER:
      return handleAddProductToOffer(payload.partNumber, payload.inReviewStage, payload.currentStep)
    case ANALYTICS_HANDLE_CHANGE_PAGE_FOR_STEP:
      return handleChangePageForStep(payload.trackNewPage, payload.pageNumber)
    case ANALYTICS_HANDLE_CHANGE_PRODUCT_IN_STEP:
      return handleChangeProductInStep(payload.step, payload.product)
    case ANALYTICS_HANDLE_ANALYTICS_SET_UP:
      return handleAnalyticsSetUp()
    case ANALYTICS_PUSH_AR3D_IN_PAGE:
      return pushAr3dInPage()
    default:
      break
  }
  return next(action)
}

export default analyticsMiddleware
